import React from "react";
import PageHero from "../components/PageHero";
import CTABanner from "../components/CTABanner";
import { PROCESS_STEPS, PHOTOS } from "../lib/data";

export default function ProcessPage() {
    return (
        <div data-testid="process-page">
            <PageHero
                eyebrow="Our process"
                title="From concept to completion."
                sub="A clear, five-stage process that takes the guesswork out of building your outdoor space."
                image={PHOTOS.poolPatioOutdoorLiving}
            />

            <section className="px-4 sm:px-8 py-12">
                <div className="max-w-5xl mx-auto">
                    <div className="relative">
                        {/* Vertical line */}
                        <div className="hidden md:block absolute left-[27px] top-2 bottom-2 w-px bg-brand-border" />
                        <div className="space-y-12">
                            {PROCESS_STEPS.map((step, i) => (
                                <div key={step.n} data-testid={`process-step-${step.n}`} className="relative grid md:grid-cols-12 gap-6 md:gap-10 items-start">
                                    <div className="md:col-span-2 flex md:block items-center gap-4">
                                        <div className="relative h-14 w-14 rounded-full bg-brand-primary text-white flex items-center justify-center font-serif text-xl font-semibold ring-8 ring-brand-bg z-10">
                                            {step.n}
                                        </div>
                                        <div className="md:hidden text-xs uppercase tracking-[0.3em] text-brand-secondary font-bold">Stage {i + 1}</div>
                                    </div>
                                    <div className="md:col-span-10">
                                        <p className="hidden md:block text-xs uppercase tracking-[0.3em] text-brand-secondary font-bold mb-2">Stage {i + 1}</p>
                                        <h3 className="font-serif text-3xl sm:text-4xl text-brand-primary font-medium leading-tight">{step.title}</h3>
                                        <p className="mt-3 text-base sm:text-lg text-brand-textMuted leading-relaxed max-w-2xl">{step.desc}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>

            <section className="px-4 sm:px-8 py-24 bg-brand-surfaceAlt">
                <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-12 items-center">
                    <div className="aspect-[4/3] rounded-2xl overflow-hidden">
                        <img src={PHOTOS.retainingWallCurved} alt="Crew at work" className="w-full h-full object-cover" />
                    </div>
                    <div>
                        <p className="text-xs uppercase tracking-[0.3em] text-brand-secondary font-bold mb-3">What you can expect</p>
                        <h2 className="font-serif text-4xl sm:text-5xl text-brand-primary leading-[1.1] font-medium tracking-tight">No surprises. Just the project, delivered.</h2>
                        <ul className="mt-7 space-y-4 text-brand-textMuted">
                            {[
                                "A detailed written estimate before any work begins.",
                                "A single project lead who's on-site each day.",
                                "Clean, organised job sites and respectful crews.",
                                "Daily progress updates via text or email — your choice.",
                                "A final walkthrough and care guidance after install.",
                            ].map((t) => (
                                <li key={t} className="flex gap-3">
                                    <span className="mt-2 h-1.5 w-1.5 rounded-full bg-brand-accent shrink-0" />
                                    <span>{t}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </section>

            <CTABanner
                eyebrow="Step one"
                title="Book your free consultation."
                primaryLabel="Schedule a Visit"
            />
        </div>
    );
}
